var _path, _linearGradient, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSourcetree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2684ff",
    d: "M40.65,19.652C40.65,10.456,33.194,3,23.998,3C15.801,2.988,8.815,8.946,7.533,17.042 S11.201,32.962,19,35.485v8.344C19,44.476,19.524,45,20.171,45h7.658C28.476,45,29,44.476,29,43.829v-8.338 C35.879,33.276,40.642,26.879,40.65,19.652z M23.998,25.279c-3.109,0-5.63-2.521-5.63-5.63s2.521-5.63,5.63-5.63 s5.63,2.521,5.63,5.63S27.107,25.279,23.998,25.279z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lgQxOMjijNeFEHZ9gijeza_Qu2sYlfDM0qZ_gr1",
    x1: 32.213,
    x2: 32.213,
    y1: 35.497,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.044,
    stopColor: "#0255cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#1c77f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#2684ff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lgQxOMjijNeFEHZ9gijeza_Qu2sYlfDM0qZ_gr1)",
    d: "M23.875,3v11.026c3.109,0,5.63,2.521,5.63,5.63s-2.521,5.63-5.63,5.63 c1.365,0,2.674,0.542,3.639,1.507c0.965,0.965,1.507,2.274,1.507,3.639v5.065c7.802-2.523,12.606-10.35,11.323-18.449 C39.062,8.949,32.075,2.989,23.875,3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.239,24.813c-0.249,0.108-0.508,0.195-0.774,0.267c-0.469,0.126-0.959,0.2-1.468,0.2 c-0.001,0-0.002,0-0.003,0c-0.04,0.001-0.079,0.006-0.119,0.006c1.365,0,2.674,0.542,3.639,1.507s1.507,2.274,1.507,3.639v5.051 c0.163-0.053,0.318-0.118,0.478-0.175c0.167-0.06,0.335-0.119,0.5-0.183v-4.749C30,27.858,28.441,25.702,26.239,24.813z",
    opacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.466,25.079c-0.469,0.126-0.959,0.2-1.468,0.2c-0.001,0-0.002,0-0.003,0 c-0.04,0.001-0.079,0.006-0.119,0.006c1.365,0,2.674,0.542,3.639,1.507s1.507,2.274,1.507,3.639v5.051 c0.163-0.053,0.318-0.118,0.478-0.175v-4.933C29.5,27.85,27.788,25.723,25.466,25.079z",
    opacity: 0.07
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourcetree);
export default __webpack_public_path__ + "static/media/sourcetree.70fbb99881e33bcd0e949ab7177f9770.svg";
export { ForwardRef as ReactComponent };